import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { DynamicPanel, GroupPanel } from '../../interfaces';
import { ServiceAgent } from 'src/app/framework-modules/formdata/form/serviceAgent';
import { SessionComponent } from '../../component';
import { PanelData } from 'src/app/framework-modules/formdata/form/formData';
import { MessageService } from 'src/app/services/messageService';
import { TableMetaData, CtTableComponent } from 'src/app/framework-modules/elements/ct-table/component';
import { CurrentApprovalVo, CurrentApprovalForm } from 'src/app/framework-modules/formdata/gen/currentApprovalForm';

@Component({
  selector: "authorisation-status",
  templateUrl: "./component.html",
  styleUrls: ["./component.scss"]
})

export class AuthorisationListComponent implements DynamicPanel, OnInit {
  @Input() inputData: any;
  @Input() parentPanel: GroupPanel;
  @Input() session: SessionComponent;
  @ViewChild("gridTable",{static:false}) gtable:CtTableComponent;
  public tableData: TableMetaData;
  /**
   * used only to get data from the server. not used for rendering data
   */
  private fd: PanelData;
  /**
   * approvals received from the server
   */
  private aprs: CurrentApprovalVo[];

  constructor(private sa: ServiceAgent, private messageService: MessageService) {
    this.initMetadata();
    this.fd = CurrentApprovalForm.getInstance().newPanelData(this.sa);
  }

  ngOnInit() {
    this.getData();
  }

  ngAfterViewInit() {
  }

  private initMetadata() {
    this.tableData = {
      data: [
      ],
      metaData: {
        column_names: [
          'requestedDate',
          'requestType',
          'approvalStatus',
          'contactPerson',
          'name',
          'usn',
          'refText'
        ],
        display_names: {
          requestedDate: 'Date',
          requestType: 'Type',
          approvalStatus:'Status',
          contactPerson: 'Requested By',
          name: 'Student',
          usn: 'USN',
          refText: 'Subject'
        },
        search: true,
        view: true,
        placeholder: "Search By Requester, Student, Subject",
      }
    }
  }

  private getData() {
  
    this.fd.filter().subscribe({
      next: list => {
        this.setData(list);
      },
      error: msg => {
        this.messageService.showError('Server returned with an error');
      }
    });
  }

  private setData(list: CurrentApprovalVo[]) {
    this.aprs = list;
    console.log(list.length + ' requests being rendered');
    this.tableData.data = list;
    this.gtable.update();
  }

  view(idx) {
    const vo = this.aprs[idx];
    const param = {
      approvalId: vo.approvalId,
      internalRefId: vo.internalRefId
    };
    this.parentPanel.navigate('AuthorisationEdit', param)
  }

}
